import script from "./UserLoginPasswordUpdateComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLoginPasswordUpdateComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserLoginPasswordUpdateComponent.vue?vue&type=style&index=0&id=48cbb45c&lang=css"

const __exports__ = script;

export default __exports__